import { createTheme } from '@mui/material/styles';
import accordion from './accordion';
import autocomplete from './autocomplete';
import baseTheme from './base';
import button from './button';
import calendar from './calendar';
import chip from './chip';
import datePicker from './datePicker';
import dialog from './dialog';
import form from './form';
import icon from './icon';
import input from './input';
import link from './link';
import list from './list';
import menu from './menu';
import switchTheme from './switch';
import tabs from './tabs';
import tooltip from './tooltip';

const theme = createTheme(baseTheme, {
  components: {
    ...accordion,
    ...autocomplete,
    // ...layout(base),
    ...input,
    // ...select,
    ...button,
    ...list,
    ...form,
    // ...table,
    ...menu,
    // ...alerts,
    ...tabs,
    // ...toggles,
    ...dialog,
    // ...pagination,
    ...tooltip,
    // ...datagrid,
    // ...loader,
    ...link,
    ...datePicker,
    ...calendar,
    ...icon,
    ...chip,
    ...switchTheme,
  },
});
export type Theme = typeof theme;
export default theme;
